import * as React from "react";
import CardV1 from "./card_v1.component";
import CardV2 from "./card_v2.component";

declare const window: any;

export default function IntroContainer({ intro, progress, setIntroView, introView, isTheme, isLoaded, isPortrait, counter }: any) {
  const [isLegaltext, setIsLegalText] = React.useState(true);
  
  return (
    <div
      className={`intro-container ${introView ? "active" : ""}`}
      style={{
        backgroundImage: `url(${window.hybrid ? (`galleries/${window?.builder_id}/${window?.project_id}/spin/General/Spin general/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}/001.webp`).replace(
          / /g,
          "%20"
        ) : (`https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/galleries/${window?.builder_id}/${window?.project_id}/spin/General/Spin general/${window.innerWidth < window.innerHeight ? "portrait" : "landscape"}/001.webp`).replace(
          / /g,
          "%20"
        ) })`,
        //backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        //display: isLegaltext ? "block" : "flex",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundPosition: 'center 50%'
      }}
    >
      {isLegaltext ? <CardV1 intro={intro} progress={progress} theme={isTheme} setIntroView={setIntroView} isLoaded={isLoaded} isPortrait={isPortrait} counter={counter} /> : <CardV2 intro={intro} progress={progress} theme={isTheme}/>}
    </div>
  );
}
